import React, { Component } from "react";
import _ from "lodash";
import anime from "animejs";
import MobileDetect from "mobile-detect";
import { withRedux } from "../hoc";
import { BackgroundImage, MyWaypoint, FeatherLoop, Image } from "../components";

const feather1 = `${process.env.PUBLIC_URL}/assets/images/ourshow-page/feather-9.png`;
const feather2 = `${process.env.PUBLIC_URL}/assets/images/ourshow-page/feather-2.png`;
const feather3 = `${process.env.PUBLIC_URL}/assets/images/ourshow-page/feather-pink.png`;
const feather4 = `${process.env.PUBLIC_URL}/assets/images/ourshow-page/feather.png`;

const md = new MobileDetect(window.navigator.userAgent);

const mapStateToProps = ({ language, t, ourshowPage }) => {
  return {
    language,
    t,
    ourshowPage: _.get(ourshowPage, "data")
  };
};

@withRedux(mapStateToProps)
class Ourshow extends Component {
  getMediaHeaderDesktop = () => {
    const { ourshowPage } = this.props;
    const media = _.get(ourshowPage, "video");
    const imageBanner = _.get(ourshowPage, "imageBanner");
    const imageBannerMobile = _.get(ourshowPage, "imageBannerMobile");

    if (md.mobile()) {
      return <BackgroundImage image={imageBanner || imageBannerMobile} />;
    } else if (imageBanner) {
      return <BackgroundImage image={imageBanner} />;
    } else {
      return (
        <iframe
          title="ourshowtiffany"
          src={`https://www.youtube.com/embed/${media}?autoplay=1&loop=1&rel=0&showinfo=0&controls=0&mute=1&color=white&iv_load_policy=3&playlist=${media}`}
          allowFullScreen
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        />
      );
    }
  };
  render() {
    const { t, ourshowPage } = this.props;
  
    const imageBanner = _.get(ourshowPage, "imageBanner");
    const imageBannerMobile = _.get(ourshowPage, "imageBannerMobile");
    const shows = _.get(ourshowPage, "shows");
    return (
      <div className="our-show-page">
        <div className="container-header">
          <div className="d-none d-md-block desktop-header" style={{ width: "100%", height: "100%" }}>
            {this.getMediaHeaderDesktop()}
          </div>
          <div className="d-md-none mobile-header" style={{ width: "100%", height: "100%" }}>
            <BackgroundImage image={imageBannerMobile || imageBanner} />
          </div>
          <div className="title-header">
            <h1>OUR SHOW</h1>
          </div>
        </div>
        <div className="container-content">
          {_.map(shows, (item, index) => {
            const isContentLeft = index % 2 === 0;
            const title = t(_.get(item, "title"));
            const subtitle = t(_.get(item, "subtitle"));
            const description = t(_.get(item, "description"));
            const image = _.get(item, "image");
            return (
              <div key={index} className="item-block">
                <div className="row no-gutters align-items-center">
                  <div className={`col-lg-6 ${isContentLeft && window.innerWidth > 700 ? "" : "order-2"}`}>
                    <div className={`item-content ${isContentLeft ? "content-left" : "content-right"}`}>
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(".our-show-page .container-content .item-block h2")[
                                index
                              ],
                              translateY: [50, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1500,
                              delay: 100
                            })
                        ]}
                      >
                        <h2>{title}</h2>
                      </MyWaypoint>
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(
                                ".our-show-page .container-content .item-block .subtitle"
                              )[index],
                              translateY: [50, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1800,
                              delay: 200
                            })
                        ]}
                      >
                        <p className="subtitle">{subtitle}</p>
                      </MyWaypoint>
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(
                                ".our-show-page .container-content .item-block .description"
                              )[index],
                              translateY: [50, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1800,
                              delay: 200
                            })
                        ]}
                      >
                        <p className="description">{description}</p>
                      </MyWaypoint>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="item-image">
                      <MyWaypoint
                        anime={[
                          () =>
                            anime({
                              targets: document.querySelectorAll(
                                ".our-show-page .container-content .item-block .background-image-component"
                              )[index],
                              translateY: [-20, 0],
                              opacity: [0, 1],
                              easing: "easeInOutSine",
                              duration: 1800,
                              delay: 300
                            })
                        ]}
                      >
                        <BackgroundImage image={image} />
                      </MyWaypoint>
                      {index === 0 && <Image className="feather-1" src={feather1} alt="" />}
                      {index === 1 && <Image className="feather-2" src={feather2} alt="" />}
                      {index === 2 && <Image className="feather-3" src={feather3} alt="" />}
                      {index === 3 && <Image className="feather-4" src={feather4} alt="" />}
                    </div>
                  </div>
                </div>
                <FeatherLoop index={index} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Ourshow;



// WEBPACK FOOTER //
// ./src/pages/Ourshow.js